import MergeTagsPlugin, {mergeTagsContentStyle} from './mergeTags';

export {
  MergeTagsPlugin,
  mergeTagsContentStyle,
}
